module.exports = __webpack_public_path__ + "static/media/home_12.c61f19fe.jpg";